"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSubmit = exports.StyledTextInput = exports.StyledForm = void 0;
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
exports.StyledForm = (0, app_1.styled)(ui_1.Form) `
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: center;
`;
exports.StyledTextInput = (0, app_1.styled)(ui_1.TextInput) `
  width: 100%;
`;
exports.StyledSubmit = (0, app_1.styled)(ui_1.Submit) `
  width: 100%;
`;
